import { useContext } from 'react';
import { UiOverlayContext, type UiOverlayState } from './UiOverlayContext';

export function useUiOverlay(): UiOverlayState {
  const ctx = useContext(UiOverlayContext);
  if (!ctx) {
    throw new Error('useUiOverlay must be used within UiOverlayProvider');
  }
  return ctx;
}
